import { useEffect } from "react";
import { Location } from "react-router-dom";
import { constructAuthDomainUrl } from "../../common/utilities/routes/routes.util";
import { LoaderView } from "../loader/loader.comp";

interface AuthDomainRedirectProps {
    targetPath: string;
    currentLocation: Location;
}

/**
 * Component that redirects to the login domain
 * Constructs a URL with the current location as the return URL
 */
export const AuthDomainRedirect = ({ targetPath, currentLocation }: AuthDomainRedirectProps) => {
    useEffect(() => {
        // Construct the return URL (where to come back after auth)
        // Don't include search params in returnUrl - they'll be added to auth domain URL
        const returnUrl = `${window.location.origin}${currentLocation.pathname}`;

        // Parse current search params to preserve them (like invite code)
        const currentParams = new URLSearchParams(currentLocation.search);

        // Build login domain URL with return URL and preserve query params
        const authParams = new URLSearchParams();
        authParams.set("returnUrl", returnUrl);

        // Pass the tenant origin so login domain can fetch the correct tenant
        authParams.set("tenantOrigin", window.location.origin);

        // Copy all existing query params to login domain URL
        currentParams.forEach((value, key) => {
            authParams.set(key, value);
        });

        const authUrl = constructAuthDomainUrl(`${targetPath}?${authParams.toString()}`);

        // Redirect to login domain
        window.location.href = authUrl;
    }, [targetPath, currentLocation]);

    // Show loading indicator while redirecting
    return <LoaderView show={true} />;
};
